import { render, staticRenderFns } from "./LedgerLoaderReport.vue?vue&type=template&id=4fdcd33f&"
import script from "./LedgerLoaderReport.vue?vue&type=script&lang=js&"
export * from "./LedgerLoaderReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports